require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-adb-disability-commitments.json") })
        }
      }, "path---en-us-update-adb-disability-commitments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-adb-disability-commitments!./.cache/json/en-us-update-adb-disability-commitments.json
// module id = 606
// module chunks = 231608221292675